import { render, staticRenderFns } from "./Univers.vue?vue&type=template&id=e020a99c&scoped=true&"
import script from "./Univers.vue?vue&type=script&lang=js&"
export * from "./Univers.vue?vue&type=script&lang=js&"
import style0 from "./Univers.vue?vue&type=style&index=0&id=e020a99c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e020a99c",
  null
  
)

export default component.exports